import {
  Film,
  Home,
  Circle,
  Tv,
  Activity,
  Video,
  Server,
  DollarSign,
  UserPlus,
  CreditCard
} from "react-feather"

export default [
  {
    id: "dashboard",
    title: "Dashboard",
    icon: <Activity size={20} />,
    // badge: "light-warning"
    // badgeText: "2"
    navLink: "/dashboard"
  },
  {
    id: "separator1",
    disabled: "true"
  },
  {
    id: "commissions",
    title: "Commissions",
    icon: <CreditCard size={20} />,

    navLink: "/commissions"
  },
  {
    id: "withdrawals",
    title: "Withdrawals",
    icon: <DollarSign size={20} />,
    navLink: "/withdrawals"
  },
  {
    id: "separator3",
    disabled: "true"
  },
  {
    id: "affiliate",
    title: "Affiliate Program",
    icon: <UserPlus size={20} />,
    badge: "light-warning",
    children: [
      {
        id: "my-affiliate",
        title: "My Affiliate",
        icon: <Circle size={12} />,
        navLink: "/affiliate-program/my-affiliate"
      },
      {
        id: "affiliate-users",
        title: "Referrals",
        icon: <Circle size={12} />,
        navLink: "/affiliate-program/affiliate-users"
      },
      {
        id: "affiliate-commissions",
        title: "Commissions",
        icon: <Circle size={12} />,
        navLink: "/affiliate-program/affiliate-commissions"
      }
    ]
  },
  {
    id: "separator4",
    disabled: "true"
  }
]
